<template>
    <v-container fluid fill-height class="my-5">
        <v-layout column justify-center align-center class="thank-you-container">
            <div class="thank-you-message">
                {{ $t('screener.leave.thank_you_message_1') }}
            </div>
            <div class="subtitle mb-2">
                {{ $t('screener.leave.thank_you_message_2') }}
            </div>
            <div class="subtitle">
                <a href="https://app.movieseverywhere.net/register" target="_blank">{{ $t('screener.mew_signup.title') }}</a>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'ThankYou'
    };
</script>

<style scoped>
.thank-you-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.thank-you-message {
    font-size: 48px;
    font-weight: bold;
    color: #4caf50; /* Green color */
    margin-bottom: 24px; /* Add margin below the main message */
}

.subtitle {
    font-size: 24px;
    color: #333; /* Dark gray color */
}
</style>
  